<div class="container-fluid">

  <h4 id="upper">Évaluation Globale (Bilan physique et financier) du PTA</h4>

  <div class="d-flex justify-content-end align-items-center flex-wrap gap-3">
    <div class="d-flex align-items-center">
      <label class="d-flex align-items-center me-3">
        Début:
        <input type="date" class="form-control ms-2" [(ngModel)]="dateDebut" name="dateDebut">
      </label>
      <label class="d-flex align-items-center">
        Fin:
        <input type="date" class="form-control ms-2" [(ngModel)]="dateFin" name="dateFin">
      </label>
    </div>

    <div id="tickets-table_filter" class="dataTables_filter">
      <button (click)="getStatistique()" type="button" class="btn btn-primary">
        <i class="pi pi-search" style="font-size: 0.8rem"></i> Rechercher
      </button>
    </div>

    <button (click)="exportPtaDetail()" type="button" class="btn btn-primary">
      <i class="pi pi-file-pdf" style="font-size: 0.8rem"></i> PTA détail
    </button>

    <!-- <button type="button" class="btn btn-outline-secondary btn-sm" (click)="expandAll()">
      <i class="pi pi-plus-circle"></i> Tout déplier
    </button>
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="collapseAll()">
      <i class="pi pi-minus-circle"></i> Tout replier
    </button> -->

    <div class="dropdown d-inline-block" ngbDropdown>
      <button type="button" ngbDropdownToggle class="btn btn-secondary dropdown-toggle" id="dropdownMenuButton"
        aria-haspopup="true" aria-expanded="false">
        Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('pdf')">Au format PDF</a>
        <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('excel')">Au format Excel</a>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-lg-12">
  <div class="card">
  <div class="card-body p-0">

    <!-- Chargement -->
    <div class="d-flex justify-content-center p-4" *ngIf="isLoading">
      <div class="text-center">
        <h5 id="graycolor">Chargement en cours</h5>
        <div class="loader4"></div>
      </div>
    </div>

    <div class="table-responsive" *ngIf="!isLoading">
      <table style="border-collapse: collapse; width: 100%; font-size: 0.875rem; font-family: inherit;">

        <!-- ── En-tête ─────────────────────────────────────────────── -->
        <thead>
          <tr style="background-color: #2c5282; color: #ebf4ff;">
            <th style="padding: 11px 14px; font-weight: 500; min-width: 340px; text-align: left; border-bottom: 2px solid #1a3a5c;">
              Programme / Actions / Activités
            </th>
            <th style="padding: 11px 10px; font-weight: 500; white-space: nowrap; border-bottom: 2px solid #1a3a5c;">
              Imputation
            </th>
            <th style="padding: 11px 10px; font-weight: 500; text-align: right; white-space: nowrap; border-bottom: 2px solid #1a3a5c;">
              Montant budgétisé
            </th>
            <th style="padding: 11px 10px; font-weight: 500; text-align: center; white-space: nowrap; border-bottom: 2px solid #1a3a5c;">
              TEP Prévu
            </th>
            <th style="padding: 11px 10px; font-weight: 500; text-align: center; white-space: nowrap; border-bottom: 2px solid #1a3a5c;">
              TEP Réel
            </th>
            <th style="padding: 11px 10px; font-weight: 500; text-align: right; white-space: nowrap; border-bottom: 2px solid #1a3a5c;">
              Total Engagé
            </th>
            <th style="padding: 11px 10px; font-weight: 500; text-align: center; white-space: nowrap; border-bottom: 2px solid #1a3a5c;">
              Taux Engagé
            </th>
            <th style="padding: 11px 10px; font-weight: 500; text-align: right; white-space: nowrap; border-bottom: 2px solid #1a3a5c;">
              Total Ordonnancé
            </th>
            <th style="padding: 11px 10px; font-weight: 500; text-align: center; white-space: nowrap; border-bottom: 2px solid #1a3a5c;">
              Taux Ordonnancé
            </th>
            <th style="padding: 11px 10px; font-weight: 500; text-align: right; white-space: nowrap; border-bottom: 2px solid #1a3a5c;">
              Total Décaissé
            </th>
            <th style="padding: 11px 10px; font-weight: 500; text-align: center; white-space: nowrap; border-bottom: 2px solid #1a3a5c;">
              Taux Décaissé
            </th>
          </tr>
        </thead>

        <tbody>

          <!-- Aucune donnée -->
          <tr *ngIf="items.length === 0">
            <td colspan="11" style="text-align: center; padding: 32px; color: #718096;">
              Aucune donnée trouvée
            </td>
          </tr>

          <!-- ── Boucle Programmes ───────────────────────────────────── -->
          <ng-container *ngFor="let progItem of items; let pi = index">

            <!-- Ligne PROGRAMME -->
            <tr (click)="toggleProgramme(pi)"
              style="
                background-color: #dbeafe;
                color: #1e3a5f;
                font-weight: 600;
                cursor: pointer;
                border-left: 5px solid #2c5282;
                border-bottom: 1px solid #bfdbfe;
              ">
              <td style="padding: 10px 14px;">
                <i [ngClass]="expandedProgrammes[pi] ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                  style="font-size: 0.72rem; margin-right: 8px; opacity: 0.7;"></i>
                <span style="font-size: 0.78rem; background: #2c5282; color: #fff; padding: 1px 7px; border-radius: 4px; margin-right: 7px; font-weight: 600; letter-spacing: 0.02em;">
                  {{ progItem.programme.sigle }}
                </span>
                {{ progItem.programme.libelle }}
              </td>
              <td style="padding: 10px; text-align: center; color: #93afc7;">—</td>
              <td style="padding: 10px; text-align: right; font-variant-numeric: tabular-nums;">
                {{ progItem.programme.cout | formatMoney:null }}
              </td>
              <td style="padding: 10px; text-align: center; font-variant-numeric: tabular-nums;">
                {{ progItem.tep_prevu  }}%
              </td>
              <td style="padding: 10px; text-align: center; font-variant-numeric: tabular-nums;">
                <span [style.color]="progItem.tep_realise > 0 ? '#166534' : '#92400e'">
                  {{ progItem.tep_realise  }}%
                </span>
              </td>
              <td style="padding: 10px; text-align: right; font-variant-numeric: tabular-nums;">{{ progItem.total_engage | formatMoney:null }}</td>
              <td style="padding: 10px; text-align: center; font-variant-numeric: tabular-nums;">{{ progItem.taux_engage  }}%</td>
              <td style="padding: 10px; text-align: right; font-variant-numeric: tabular-nums;">{{ progItem.total_ordonnance | formatMoney:null }}</td>
              <td style="padding: 10px; text-align: center; font-variant-numeric: tabular-nums;">{{ progItem.taux_ordonnance }}%</td>
              <td style="padding: 10px; text-align: right; font-variant-numeric: tabular-nums;">{{ progItem.total_decaisse | formatMoney:null }}</td>
              <td style="padding: 10px; text-align: center; font-variant-numeric: tabular-nums;">{{ progItem.taux_decaisse   }}%</td>
            </tr>

            <!-- ── Boucle Actions ─────────────────────────────────────── -->
            <ng-container *ngIf="expandedProgrammes[pi]">
              <ng-container *ngFor="let actionItem of progItem.actions; let ai = index">

                <!-- Ligne ACTION -->
                <tr (click)="toggleAction(pi, ai)"
                  style="
                    background-color: #f0f7ff;
                    color: #2d4a6a;
                    font-weight: 500;
                    cursor: pointer;
                    border-left: 5px solid #7ab0d8;
                    border-bottom: 1px solid #e2eef8;
                  ">
                  <td style="padding: 9px 14px 9px 30px;">
                    <i [ngClass]="isActionExpanded(pi, ai) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                      style="font-size: 0.68rem; margin-right: 8px; opacity: 0.6;"></i>
                    <span style="font-size: 0.76rem; background: #7ab0d8; color: #fff; padding: 1px 6px; border-radius: 3px; margin-right: 6px; font-weight: 600;">
                      {{ actionItem.action.code }}
                    </span>
                    {{ actionItem.action.libelle }}
                  </td>
                  <td style="padding: 9px 10px; text-align: center; color: #a0b8cc;">—</td>
                  <td style="padding: 9px 10px; text-align: right; font-variant-numeric: tabular-nums;">{{ actionItem.action.montant | formatMoney:null }}</td>
                  <td style="padding: 9px 10px; text-align: center; font-variant-numeric: tabular-nums;">{{ actionItem.tep_prevu  }}%</td>
                  <td style="padding: 9px 10px; text-align: center; font-variant-numeric: tabular-nums;">
                    <span [style.color]="actionItem.tep_realise > 0 ? '#166534' : '#92400e'">
                      {{ actionItem.tep_realise  }}%
                    </span>
                  </td>
                  <td style="padding: 9px 10px; text-align: right; font-variant-numeric: tabular-nums;">{{ actionItem.total_engage | formatMoney:null }}</td>
                  <td style="padding: 9px 10px; text-align: center; font-variant-numeric: tabular-nums;">{{ actionItem.taux_engage  }}%</td>
                  <td style="padding: 9px 10px; text-align: right; font-variant-numeric: tabular-nums;">{{ actionItem.total_ordonnance | formatMoney:null }}</td>
                  <td style="padding: 9px 10px; text-align: center; font-variant-numeric: tabular-nums;">{{ actionItem.taux_ordonnance}}%</td>
                  <td style="padding: 9px 10px; text-align: right; font-variant-numeric: tabular-nums;">{{ actionItem.total_decaisse | formatMoney:null }}</td>
                  <td style="padding: 9px 10px; text-align: center; font-variant-numeric: tabular-nums;">{{ actionItem.taux_decaisse  }}%</td>
                </tr>

                <!-- ── Boucle Activités ──────────────────────────────────── -->
                <ng-container *ngIf="isActionExpanded(pi, ai)">
                  <tr *ngFor="let activiteItem of actionItem.activites; let odd = odd"
                    [style.background-color]="odd ? '#fafcff' : '#ffffff'"
                    style="
                      border-left: 5px solid #d4e8f5;
                      border-bottom: 1px solid #edf2f7;
                      color: #3d4f61;
                    ">
                    <td style="padding: 7px 14px 7px 58px; font-size: 0.83rem;">
                      <span style="
                        display: inline-block; width: 6px; height: 6px;
                        border-radius: 50%; background-color: #c3d9ea;
                        margin-right: 8px; vertical-align: middle;
                      "></span>
                      <span style="color: #a8c4d9; font-weight: 500; margin-right: 5px; font-size: 0.8rem;">
                        {{ activiteItem.activite.code_activite }} -
                        {{ activiteItem.activite.detail_activite_pdc_code }}
                      </span>
                      {{ activiteItem.activite.activite }}
                    </td>
                    <td style="padding: 7px 10px; font-size: 0.82rem; color: #718096; text-align: left;">
                      {{ activiteItem.activite.amputation_budgetaire }}
                    </td>
                    <td style="padding: 7px 10px; text-align: right; font-size: 0.83rem; font-variant-numeric: tabular-nums;">{{ activiteItem.activite.total | formatMoney:null }}</td>
                    <td style="padding: 7px 10px; text-align: center; font-size: 0.83rem; font-variant-numeric: tabular-nums;">{{ activiteItem.tep_prevu  }}%</td>
                    <td style="padding: 7px 10px; text-align: center; font-size: 0.83rem; font-variant-numeric: tabular-nums;">
                      <span [style.color]="activiteItem.tep_realise > 0 ? '#166534' : '#92400e'">
                        {{ activiteItem.tep_realise  }}%
                      </span>
                    </td>
                    <td style="padding: 7px 10px; text-align: right; font-size: 0.83rem; font-variant-numeric: tabular-nums;">{{ activiteItem.total_engage | formatMoney:null }}</td>
                    <td style="padding: 7px 10px; text-align: center; font-size: 0.83rem; font-variant-numeric: tabular-nums;">{{ activiteItem.taux_engage   }}%</td>
                    <td style="padding: 7px 10px; text-align: right; font-size: 0.83rem; font-variant-numeric: tabular-nums;">{{ activiteItem.total_ordonnance | formatMoney:null }}</td>
                    <td style="padding: 7px 10px; text-align: center; font-size: 0.83rem; font-variant-numeric: tabular-nums;">{{ activiteItem.taux_ordonnance  }}%</td>
                    <td style="padding: 7px 10px; text-align: right; font-size: 0.83rem; font-variant-numeric: tabular-nums;">{{ activiteItem.total_decaisse | formatMoney:null }}</td>
                    <td style="padding: 7px 10px; text-align: center; font-size: 0.83rem; font-variant-numeric: tabular-nums;">{{ activiteItem.taux_decaisse   }}%</td>
                  </tr>
                </ng-container>

              </ng-container>
            </ng-container>

          </ng-container>

          <!-- ═══════════════════════════════════════════════════════════════ -->
          <!-- LIGNE DE TOTAL GÉNÉRAL -->
          <!-- ═══════════════════════════════════════════════════════════════ -->
          <tr *ngIf="items.length > 0" style="
            background-color: #1e3a5f;
            color: #ffffff;
            font-weight: 700;
            border-top: 3px solid #ffc107;
            border-bottom: 2px solid #ffc107;
          ">
            <td style="padding: 12px 14px; font-size: 0.9rem; font-weight: 700;">
              <i class="pi pi-calculator" style="margin-right: 8px;"></i>
              TOTAL GÉNÉRAL
            </td>
            <td style="padding: 12px 10px; text-align: center;">—</td>
            <td style="padding: 12px 10px; text-align: right; font-weight: 700; font-size: 1rem;">
              {{ getTotalMontantBudgetise() | formatMoney:null }}
            </td>
            <td style="padding: 12px 10px; text-align: center; font-weight: 600;">
              {{ getTauxMoyenPondere('tep_prevu')  }}%
            </td>
            <td style="padding: 12px 10px; text-align: center; font-weight: 600;">
              {{ getTauxMoyenPondere('tep_realise')  }}%
            </td>
            <td style="padding: 12px 10px; text-align: right; font-weight: 700;">
              {{ getTotalEngage() | formatMoney:null }}
            </td>
            <td style="padding: 12px 10px; text-align: center; font-weight: 600;">
              {{ getTauxMoyenPondere('taux_engage')  }}%
            </td>
            <td style="padding: 12px 10px; text-align: right; font-weight: 700;">
              {{ getTotalOrdonnance() | formatMoney:null }}
            </td>
            <td style="padding: 12px 10px; text-align: center; font-weight: 600;">
              {{ getTauxMoyenPondere('taux_ordonnance')  }}%
            </td>
            <td style="padding: 12px 10px; text-align: right; font-weight: 700;">
              {{ getTotalDecaisse() | formatMoney:null }}
            </td>
            <td style="padding: 12px 10px; text-align: center; font-weight: 600;">
              {{ getTauxMoyenPondere('taux_decaisse')  }}%
            </td>
          </tr>

        </tbody>
      </table>
    </div>

  </div>
</div>
    </div>
  </div>

</div>

<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>